export default __webpack_public_path__ + "static/media/home-green.d1454ec6.svg";